import React, { ReactElement } from 'react';
import {
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Stack,
    Typography,
} from '@mui/material';
import { CheckOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from '../../contexts/TranslationContext';
import { SnackbarContentProps, useSnackbar } from 'notistack';
import { useTheme } from '@mui/material/styles';
import { User } from '../../store/types';

interface UserCreatedSnackbarProps extends SnackbarContentProps {
    user: User;
    action: ReactElement;
}

const UserCreatedSnackbar = React.forwardRef(
    (props: UserCreatedSnackbarProps, ref) => {
        const theme = useTheme();
        const { translate } = useTranslation();
        const { closeSnackbar } = useSnackbar();
        const { user, id, ...otherProps } = props;

        return (
            <Box ref={ref} {...otherProps}>
                <Accordion sx={{ overflow: 'hidden' }}>
                    <AccordionSummary
                        expandIcon={<DownOutlined />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{ background: theme.palette.success.dark }}>
                        <Stack spacing={1} direction="row" alignItems="center">
                            <CheckOutlined
                                style={{
                                    fontSize: 18,
                                    color: theme.palette.success.contrastText,
                                }}
                            />
                            <Typography
                                sx={{
                                    fontWeight: 'bold',
                                    color: theme.palette.success.contrastText,
                                }}>
                                {translate('pages.admin.user.created.title')}
                            </Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails sx={{ py: 2 }}>
                        <Typography>
                            {translate(
                                'pages.admin.user.created.email',
                                user.email,
                            )}
                        </Typography>
                        <Typography>
                            {translate(
                                'pages.admin.user.created.password',
                                user.plain_password,
                            )}
                        </Typography>
                    </AccordionDetails>
                    <AccordionActions>
                        <Button
                            color="success"
                            onClick={() => closeSnackbar(id)}
                            sx={{ textTransform: 'unset' }}>
                            {translate('pages.admin.user.created.btn')}
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
        );
    },
);
export default UserCreatedSnackbar;
